import _ from 'lodash'
import chroma from 'chroma-js'

const fmt = (num, radix=4) => num.toFixed(radix),
      s = num => num==1 ? '' : 's',
      greyscale = chroma.scale('Greys'),
      palette = chroma.scale('YlOrBr'),
      rewind = chroma.scale('PuBuGn'),
      ffwd = chroma.scale('PuBu'),
      cancel = e => (e.preventDefault(), e.stopPropagation()),
      offset = (cx, cy, angle, dist) => {
        var theta = angle/360 * 2*Math.PI
        return {x:cx+Math.cos(theta) * dist,
                y:cy+Math.sin(theta) * dist}
      },
      sfc32 = (seed) => {
        let a = 0x9E3779B9,
            b = 0x243F6A88,
            c = 0xB7E15162,
            d = seed ^ 0xDECAFBAD;
        return function() {
          a >>>= 0; b >>>= 0; c >>>= 0; d >>>= 0;
          var t = (a + b) | 0;
          a = b ^ b >>> 9;
          b = c + (c << 3) | 0;
          c = (c << 21 | c >>> 11);
          d = d + 1 | 0;
          t = t + d | 0;
          c = c + t | 0;
          return (t >>> 0) / 4294967296;
        }
      }

  //(x0,y0) is start point; (x1,y1),(x2,y2) is control points; (x3,y3) is end point.

  function quadMinMax(x0, y0, cx, cy, x1, y1){
    let cx1 = x0 + 2/3 * (cx-x0),
        cy1 = y0 + 2/3 * (cy-y0),
        cx2 = x1 + 2/3 * (cx-x1),
        cy2 = y1 + 2/3 * (cy-y1);
    return bezierMinMax(x0, y0, cx1, cy1, cx2, cy2, x1, y1)
  }

  function bezierMinMax(x0, y0, x1, y1, x2, y2, x3, y3) {
      var tvalues = [], xvalues = [], yvalues = [],
          a, b, c, t, t1, t2, b2ac, sqrtb2ac;
      for (var i = 0; i < 2; ++i) {
          if (i == 0) {
              b = 6 * x0 - 12 * x1 + 6 * x2;
              a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
              c = 3 * x1 - 3 * x0;
          } else {
              b = 6 * y0 - 12 * y1 + 6 * y2;
              a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
              c = 3 * y1 - 3 * y0;
          }
          if (Math.abs(a) < 1e-12) {
              if (Math.abs(b) < 1e-12) {
                  continue;
              }
              t = -c / b;
              if (0 < t && t < 1) {
                  tvalues.push(t);
              }
              continue;
          }
          b2ac = b * b - 4 * c * a;
          if (b2ac < 0) {
              if (Math.abs(b2ac) < 1e-12) {
                  t = -b / (2 * a);
                  if (0 < t && t < 1) {
                      tvalues.push(t);
                  }
              }
              continue;
          }
          sqrtb2ac = Math.sqrt(b2ac);
          t1 = (-b + sqrtb2ac) / (2 * a);
          if (0 < t1 && t1 < 1) {
              tvalues.push(t1);
          }
          t2 = (-b - sqrtb2ac) / (2 * a);
          if (0 < t2 && t2 < 1) {
              tvalues.push(t2);
          }
      }

      var j = tvalues.length, mt;
      while (j--) {
          t = tvalues[j];
          mt = 1 - t;
          xvalues[j] = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
          yvalues[j] = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
      }

      xvalues.push(x0,x3);
      yvalues.push(y0,y3);

      return {
          min: {x: Math.min.apply(0, xvalues), y: Math.min.apply(0, yvalues)},
          max: {x: Math.max.apply(0, xvalues), y: Math.max.apply(0, yvalues)}
      };
  }




  //
  // ANIMATION
  //
  const EASING = {
    linear:  function (t, b, c, d) {        return c*t/d + b },

    easeInQuad: function (t, b, c, d) {     return c*(t/=d)*t + b },
    easeOutQuad: function (t, b, c, d) {    return -c *(t/=d)*(t-2) + b },
    easeInOutQuad: function (t, b, c, d) {  return ((t/=d/2) < 1) ? c/2*t*t + b
                                                                  : -c/2 * ((--t)*(t-2) - 1) + b },
    easeInCubic: function (t, b, c, d) {    return c*(t/=d)*t*t + b },
    easeOutCubic: function (t, b, c, d) {   return c*((t=t/d-1)*t*t + 1) + b },
    easeInOutCubic: function (t, b, c, d) { return ((t/=d/2) < 1) ? c/2*t*t*t + b
                                                                  : c/2*((t-=2)*t*t + 2) + b },
    easeInQuart: function (t, b, c, d) {    return c*(t/=d)*t*t*t + b },
    easeOutQuart: function (t, b, c, d) {   return -c * ((t=t/d-1)*t*t*t - 1) + b },
    easeInOutQuart: function (t, b, c, d) { return ((t/=d/2) < 1) ? c/2*t*t*t*t + b
                                                                  : -c/2 * ((t-=2)*t*t*t - 2) + b },
    easeInQuint: function (t, b, c, d) {    return c*(t/=d)*t*t*t*t + b },
    easeOutQuint: function (t, b, c, d) {   return c*((t=t/d-1)*t*t*t*t + 1) + b },
    easeInOutQuint: function (t, b, c, d) { return ((t/=d/2) < 1) ? c/2*t*t*t*t*t + b
                                                                  : c/2*((t-=2)*t*t*t*t + 2) + b },
    easeInSine: function (t, b, c, d) {     return -c * Math.cos(t/d * (Math.PI/2)) + c + b },
    easeOutSine: function (t, b, c, d) {    return c * Math.sin(t/d * (Math.PI/2)) + b },
    easeInOutSine: function (t, b, c, d) {  return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b },

    easeInCirc: function (t, b, c, d) {     return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b },
    easeOutCirc: function (t, b, c, d) {    return c * Math.sqrt(1 - (t=t/d-1)*t) + b },
    easeInOutCirc: function (t, b, c, d) {  return ((t/=d/2) < 1) ? -c/2 * (Math.sqrt(1 - t*t) - 1) + b
                                                                  :  c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b },
    easeInExpo: function (t, b, c, d) {     return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b },
    easeOutExpo: function (t, b, c, d) {    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b },
    easeInOutExpo: function (t, b, c, d) {  return (t==0) ? b
                                                 : (t==d) ? b+c
                                                 : ((t/=d/2) < 1) ? c/2 * Math.pow(2, 10 * (t - 1)) + b
                                                 : c/2 * (-Math.pow(2, -10 * --t) + 2) + b }
  }

  var easing = function({ease='linear', at=0, to=1, rng=1}={}){
    ease = (typeof arguments[0]=='string') ? arguments[0] : ease
    return (pos) => EASING[ease](_.clamp(pos, 0, rng), at, to-at, rng)
  }

  var tween = function({at=0, to=1, dur=1000, ease='easeOutQuart', start=true, precision=3, step=_.noop, complete=_.noop}){
    const now = () => new Date(),
          progress = (rng=1.0) => rng * Math.min(dur, now() - since) / dur,
          rAF = () => window.requestAnimationFrame(tick);

    let since = now(),
        interp = _.get(EASING, ease, EASING.easeOutQuart),
        halt = start ? false : Number.EPSILON;

    function tick(){
      var pos = progress(dur),
          val = interp(pos, at, to-at, dur),
          mag = 10 * precision;
      if (Math.round(val*mag)==Math.round(to*mag) || pos>=dur)
        [val, pos] = [to, dur] // short circuit once the anim is asymptotic
      if (halt) halt = pos/dur
      else if (step(val)===false || pos==dur) complete()
      else rAF()
    }

    let anim = {
      get progress(){ return halt || progress()},
      set progress(p){ halt = _.clamp(p, 0, 1)},
      get now(){ return anim.progress * dur },
      set now(t){ anim.progress = t/dur },
      get dur(){ return dur },
      set dur(v){
        since = now() - progress(v)
        dur = v
      },
      stop:(update) => {
        halt = anim.progress
      },
      start:() => {
        if (halt){
          since = now() - halt * dur
          rAF()
        }
        halt = false
      }
    }

    if (start) rAF()
    return anim
  }

  const spring = ({at=0, to=1, stiffness=15, damping=6, mass=.10, precision=1.9, limit=0, step=_.noop, complete=_.noop}) => {
    const rAF = () => window.requestAnimationFrame(tick),
          resume = () => { since = Date.now(); rAF() },
          limiter = limit ? v => _.clamp(v, -limit, limit) : _.identity;

    let velocity = 0,
        thresh = Math.pow(10, -precision),
        since = Date.now(),
        halt, done;

    const tick = () => {
      var now = Date.now(),
          dt = Math.min(1000, now - since) / 1000; // don't explode due to suspended raf

      var force = stiffness * (to - at)
      var damp = damping * velocity
      var accel = (force - damp) / mass
      velocity += accel * dt
      at += limiter(velocity) * dt
      since = now;

      done = (Math.abs(velocity) <= thresh) && (Math.abs(to - at) <= thresh)
      if (step(done ? to : at)===false || done) complete()
      else if (!halt) rAF()
    }

    let sim = {
      get at(){ return at },
      set at(val){ at = parseFloat(val) },
      get to(){ return to },
      set to(val){
        to = parseFloat(val)
        if (done && !halt) resume()
      },
      set: (opts) => {
        opts = _.isNumber(opts) ? {at:opts, to:opts} : opts
        sim.at=_.get(opts, 'at', at);
        sim.to=_.get(opts, 'to', to)
        return sim
      },
      stop: () => { halt = true },
      start: () => {
        if (halt) resume()
        halt = false
      }
    }

    rAF()
    return sim.set({at, to})
  }


  var scrollPage = ({to=0, dur=1000, complete=_.noop}) => {
    let at = document.documentElement.scrollTop || document.body.scrollTop
    to = _.hasIn(to, 'offset') ? to.offset().top - 20 : to // `to` can be a y value or an elt
    return tween({
      at, to, dur, complete,
      step:(y) => {document.body.scrollTop = y; document.documentElement.scrollTop = y}
    })
  }

  //
  // REQUESTS
  //

  const XHR = callback => _.extend(new XMLHttpRequest(), {
    onload(){
      let {status, responseText} = this,
          err = status < 200 || status >= 400,
          data = !err && JSON.parse(responseText);
      if (err) callback(status)
      else callback(null, data)
    },
    onerror(){ callback('xhr-error') }
  })

  var getJSON = (url, callback) => {
    let request = XHR(callback)
    request.open('GET', url, true)
    request.send()
    return request
  }

  var postJSON = (url, data, callback) => {
    let request = XHR(callback),
        payload = data instanceof Blob ? data : JSON.stringify(data);
    request.open('POST', url, true)
    request.setRequestHeader("Content-Type", "application/json");
    request.send(payload)
    return request
  }


  //
  // BEZIER INTERPOLATION
  //

  function getQuadraticPoint(src, ctrl, dst, pct) {
    var inv = 1-pct,
        x = Math.pow(inv, 2) * src.x + 2*inv * pct * ctrl.x + Math.pow(pct,2) * dst.x,
        y = Math.pow(inv, 2) * src.y + 2*inv * pct * ctrl.y + Math.pow(pct,2) * dst.y;
    return {x,y}
  }


export {
  fmt, s, greyscale, palette, rewind, ffwd, cancel, offset, sfc32, quadMinMax, bezierMinMax,
  spring, tween, easing, scrollPage, getJSON, postJSON, getQuadraticPoint
}
